module.exports = __webpack_public_path__ + "media/beep.c6905338.mp3";